import { render, staticRenderFns } from "./ConsultationAside.vue?vue&type=template&id=125aeb8c&"
import script from "./ConsultationAside.vue?vue&type=script&lang=js&"
export * from "./ConsultationAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports